/*! RZC – Naruto (mirror Pokémon confirm-remove) */
(function () {
    if (window.__RZC_NAR_COLLECTION_V3__ || window.__RZC_NAR_COLLECTION_ACTIVE__) return;
    window.__RZC_NAR_COLLECTION_V3__ = true;
    window.__RZC_NAR_COLLECTION_ACTIVE__ = true;

    const root = document.getElementById("rzc-nar");
    if (!root) return;

    requestAnimationFrame(() => {
        root.classList.remove("lz-prepaint");
        root.classList.add("lz-painted");
    });

    const seriesHandle = root.dataset.lzSeriesHandle || root.getAttribute("data-lz-series-handle") || "";
    const universe = root.dataset.lzUniverse || root.dataset.lzLicense || "naruto";
    const customerEmail = root.dataset.lzCustomerEmail || root.getAttribute("data-lz-customer-email") || "";
    const loginUrl = root.dataset.lzLoginUrl || root.getAttribute("data-lz-login-url") || "/account/login";
    const normalizedEmail = (customerEmail || "").trim().toLowerCase();
    const isLoggedIn = !!normalizedEmail;

    // --- AJAX ADD TO CART ---
    root.addEventListener("submit", async (e) => {
        const form = e.target.closest(".rzc-var-form");
        if (!form || !root.contains(form)) return;
        e.preventDefault();

        const btn = form.querySelector(".rzc-var-btn");
        if (btn && btn.classList.contains("is-disabled")) {
            showToast("❌ Non Disponible", true);
            return;
        }

        if (btn) btn.classList.add("is-loading");
        const formData = new FormData(form);
        const items = [{ id: formData.get("id"), quantity: 1 }];

        try {
            await addBatch(items);
            showToast("✅ Ajouté au panier");
            await refreshCartCount();
        } catch (err) {
            showToast("Erreur d'ajout", true);
            console.error(err);
        } finally {
            if (btn) btn.classList.remove("is-loading");
        }
    });

    // --- UI HELPERS ---
    const fabProgressPanel = document.getElementById("lz-fab-progress");

    function setFabOpen(isOpen) {
        root.classList.toggle("lz-fab-open", !!isOpen);
        if (fabProgressPanel) {
            fabProgressPanel.setAttribute("aria-hidden", isOpen ? "false" : "true");
        }
        if (window.innerWidth < 768) {
            const crisp = document.querySelector(".crisp-client");
            if (crisp) crisp.style.display = isOpen ? "none" : "";
        }
    }

    const fabTrigger = document.getElementById("lz-fab-trigger");
    if (fabTrigger) {
        fabTrigger.addEventListener("click", (ev) => {
            ev.preventDefault();
            ev.stopImmediatePropagation();

            if (!isLoggedIn) {
                showToast("Connecte-toi !");
                window.location.href = loginUrl;
                return;
            }

            setFabOpen(!root.classList.contains("lz-fab-open"));
            updateAllStats();
        });
    }

    const fabClose = document.getElementById("lz-fab-close");
    if (fabClose) {
        fabClose.addEventListener("click", (ev) => {
            ev.preventDefault();
            setFabOpen(false);
        });
    }

    function syncFabTogglesFromPanel() {
        const fabSwitches = root.querySelectorAll(".lz-fab-switch");
        const baseSwitches = {
            collection: root.querySelector(".lz-collection-switch:not(.lz-fab-switch)"),
            available: root.querySelector(".lz-available-switch:not(.lz-fab-switch)"),
            missing: root.querySelector(".lz-missing-switch:not(.lz-fab-switch)")
        };

        fabSwitches.forEach((fabSw) => {
            const baseSw = baseSwitches[fabSw.dataset.control];
            if (baseSw) {
                const isOn = baseSw.dataset.on === "1";
                fabSw.dataset.on = isOn ? "1" : "0";
                fabSw.classList.toggle("is-on", isOn);
                fabSw.closest(".lz-fab-bar-group")?.classList.toggle("is-on", isOn);
            }
        });
    }

    const detailsToggle = root.querySelector(".lz-masterset-toggle-details");
    const detailsDiv = root.querySelector("#lz-masterset-details");
    if (detailsToggle && detailsDiv) {
        detailsToggle.addEventListener("click", () => {
            const isHidden = detailsDiv.hidden;
            detailsDiv.hidden = !isHidden;
            detailsToggle.textContent = isHidden ? "Masquer le détail" : "Voir le détail";
        });
    }

    // --- STATE + PERSISTENCE via Edge Function lz-api ---
    // (plus d'accès direct à Supabase — voir assets/lz-api-client.js)
    let lzOwnedFromSupabase = new Set();
    let lzOwnedVariantsFromSupabase = new Set();

    async function loadOwnedFromSupabase() {
        if (!normalizedEmail) {
            updateAllStats();
            return;
        }
        if (!window.lzApi) {
            console.warn("[RZC NAR] window.lzApi non disponible — tracking désactivé.");
            updateAllStats();
            return;
        }

        try {
            const res = await window.lzApi.collectionLoad({ email: normalizedEmail, universe });
            if (!res.ok) {
                console.error("[RZC NAR] collectionLoad error:", res);
                updateAllStats();
                return;
            }

            lzOwnedFromSupabase         = new Set(res.data.products || []);
            lzOwnedVariantsFromSupabase = new Set(res.data.variants || []);

            root.querySelectorAll(".rzc-item.lz-collection-item").forEach((item) => {
                const pid = String(item.dataset.productId || item.getAttribute("data-product-id") || "");
                if (lzOwnedFromSupabase.has(pid)) {
                    item.classList.add("lz-owned");
                    const pt = getPrimaryVariantToggle(item);
                    if (pt) {
                        pt.dataset.owned = "true";
                        pt.dataset.confirmRemove = "0";
                        pt.classList.remove("is-confirm-remove");
                        pt.textContent = "✅";
                        syncPrimaryMainVariantButton(item, true);
                    }
                }
            });

            root.querySelectorAll(".lz-var-toggle-owned").forEach((btn) => {
                if (lzOwnedVariantsFromSupabase.has(String(btn.dataset.variantId))) {
                    btn.dataset.owned = "true";
                    btn.dataset.confirmRemove = "0";
                    btn.classList.remove("is-confirm-remove");
                    btn.textContent = "✅";
                    btn.closest(".rzc-var-form")?.querySelector(".rzc-var-btn")?.classList.add("lz-var-owned");
                }
            });

            updateAllStats();
            syncFabTogglesFromPanel();
        } catch (e) {
            console.error("[RZC NAR] loadOwnedFromSupabase exception:", e);
            updateAllStats();
        }
    }

    const bootOwned = async () => {
        await loadOwnedFromSupabase();
        if (isLoggedIn) {
            updateAllStats();
        }
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bootOwned);
    } else {
        bootOwned();
    }

    // --- PERSISTENCE ---
    async function persistOwnedState(pid, owned, title) {
        if (!normalizedEmail || !window.lzApi) return;
        const res = await window.lzApi.toggleProduct({
            email: normalizedEmail,
            universe,
            productId: String(pid),
            owned,
            seriesHandle,
            productTitle: title || "",
        });
        if (!res.ok) console.error("[RZC NAR] toggleProduct error:", res);
    }

    async function persistVariantOwnedState(vid, owned, pid, ptitle, kind) {
        if (!normalizedEmail || !window.lzApi) return;
        // Normalisation : 'standard' (legacy naruto) → 'normal' pour cohérence cross-univers.
        // L'Edge Function le ferait aussi mais on le fait côté front pour garder la bonne valeur localement.
        const normalizedKind = (kind === 'standard') ? 'normal' : (kind || '');
        const res = await window.lzApi.toggleVariant({
            email: normalizedEmail,
            universe,
            variantId: String(vid),
            owned,
            variantKind: normalizedKind,
            seriesHandle,
            productTitle: ptitle || "",
        });
        if (!res.ok) console.error("[RZC NAR] toggleVariant error:", res);
    }

    async function syncSeriesProgressToSupabase(g) {
        if (!normalizedEmail || !seriesHandle || !window.lzApi) return;
        const res = await window.lzApi.syncProgress({
            email: normalizedEmail,
            universe,
            seriesHandle,
            seriesTitle: document.title,
            totalCards: g.total,
            ownedCards: g.owned,
            totalReverseCards: 0,
            ownedReverseCards: 0,
        });
        if (!res.ok) console.error("[RZC NAR] syncProgress error:", res);
    }

    // --- SHOPIFY HELPERS ---
    function showToast(text, isError) {
        let el = root.querySelector(".rzc-toast");
        if (!el) {
            el = document.createElement("div");
            el.className = "rzc-toast";
            root.appendChild(el);
        }

        el.classList.toggle("is-error", !!isError);
        el.textContent = text;
        el.style.display = "block";

        clearTimeout(showToast.timer);
        showToast.timer = setTimeout(() => {
            el.style.display = "none";
        }, 1800);
    }

    async function refreshCartCount() {
        try {
            const r = await fetch("/cart.js");
            const c = await r.json();
            document.querySelectorAll("[data-cart-count], .cart-count-bubble").forEach((e) => {
                e.textContent = c.item_count;
            });
        } catch (e) {}
    }

    async function addBatch(items) {
        const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items })
        });

        if (!res.ok) throw new Error("Erreur");
    }

    // --- DATA HANDLING ---
    const variantToItem = new Map();
    const variantPrices = new Map();

    let allItems = Array.from(root.querySelectorAll(".rzc-item"));
    let collectionItems = Array.from(root.querySelectorAll(".lz-collection-item"));
    let filterPill = null;

    function buildVariantMaps() {
        variantToItem.clear();
        variantPrices.clear();

        allItems.forEach((li) => {
            li.querySelectorAll(".rzc-var-form").forEach((f) => {
                const id = parseInt(f.querySelector('input[name="id"]')?.value, 10);
                if (id) {
                    const p = f.querySelector(".rzc-var-price")?.textContent
                        .replace(/[^\d,.]/g, "")
                        .replace(",", ".");
                    if (p) variantPrices.set(id, parseFloat(p));
                    variantToItem.set(id, li);
                }
            });
        });
    }

    buildVariantMaps();

    async function preloadNextPages() {
        const grid = root.querySelector(".rzc-grid");
        if (!grid) return;

        let nextUrl = document.getElementById("rzc-next-page")?.dataset.nextUrl;
        let guard = 0;

        while (nextUrl && guard < 20) {
            guard++;
            try {
                const res = await fetch(nextUrl, { credentials: "same-origin" });
                if (!res.ok) break;

                const doc = new DOMParser().parseFromString(await res.text(), "text/html");
                doc.querySelectorAll("#rzc-nar .rzc-grid > .rzc-item").forEach((li) => grid.appendChild(li));
                nextUrl = doc.querySelector("#rzc-next-page")?.dataset.nextUrl || null;
            } catch (e) {
                break;
            }
        }

        allItems = Array.from(root.querySelectorAll(".rzc-item"));
        collectionItems = Array.from(root.querySelectorAll(".lz-collection-item"));
        buildVariantMaps();

        if (lzOwnedFromSupabase.size || lzOwnedVariantsFromSupabase.size) {
            loadOwnedFromSupabase();
        }
    }

    function getVariantKindForId(li, id) {
        return li.querySelector(`.lz-var-toggle-owned[data-variant-id="${id}"]`)?.dataset.kind || "standard";
    }

    function getPrimaryVariantToggle(li) {
        return li.querySelector(".lz-var-toggle-owned");
    }

    function syncPrimaryMainVariantButton(li, owned) {
        const vid = getPrimaryVariantToggle(li)?.dataset.variantId;
        if (vid) {
            li.querySelector(`.rzc-var-form input[value="${vid}"]`)
                ?.closest("form")
                ?.querySelector(".rzc-var-btn")
                ?.classList.toggle("lz-var-owned", owned);
        }
    }

    function isCardFullyOwned(li) {
        if (!li.classList.contains("lz-owned")) return false;
        return Array.from(li.querySelectorAll(".lz-var-toggle-owned")).every((b) => b.dataset.owned === "true");
    }

    // --- BULK PILLS ---
    const bulkPills = Array.from(root.querySelectorAll(".rzc-bulk"));
    bulkPills.forEach((p) => {
        p._fullIds = (p.dataset.ids || "").split(",").map(Number).filter((n) => n);
    });

    function recomputeBulkPills() {
        bulkPills.forEach((pill) => {
            const missingIds = (pill._fullIds || []).filter((id) => {
                const li = variantToItem.get(id);
                if (!li) return true;

                if (pill.classList.contains("is-all")) {
                    const k = getVariantKindForId(li, id);
                    if (["standard", "normal", "common", "uncommon", "rare", "super", "sr", "secret", "sec", "alt", "alt-art", "promo", "special", "leader", "reverse"].includes(k)) {
                        return !li.querySelector(`.lz-var-toggle-owned[data-variant-id="${id}"][data-owned="true"]`) && !li.classList.contains("lz-owned");
                    }
                }

                return !li.classList.contains("lz-owned");
            });

            if (!missingIds.length) {
                pill.style.display = "none";
                pill.classList.remove("is-open");
                removeControls(pill);
            } else {
                pill.style.display = "";
                pill.dataset.ids = missingIds.join(",");

                const tot = missingIds.reduce((s, i) => s + (variantPrices.get(i) || 0), 0);
                const meta = pill.querySelector(".rzc-bulk-meta");
                if (meta) {
                    meta.textContent = `${missingIds.length} Cartes • ${tot.toFixed(2).replace(".", ",")}€`;
                }
            }
        });
    }

    function injectControls(pill) {
        if (pill.querySelector(".rzc-controls")) return;

        const d = document.createElement("div");
        d.className = "rzc-controls";
        d.innerHTML = `<button type="button" class="rzc-ctrl" data-action="cart">Panier</button><button type="button" class="rzc-ctrl" data-action="filter">Filtrer</button>`;
        pill.appendChild(d);
    }

    function removeControls(pill) {
        pill.querySelector(".rzc-controls")?.remove();
    }

    function applyFilterForPill(pill) {
        const ids = new Set((pill.dataset.ids || "").split(",").map(Number));
        allItems.forEach((li) => {
            const match = Array.from(li.querySelectorAll('input[name="id"]')).some((inp) => ids.has(parseInt(inp.value, 10)));
            li.classList.toggle("is-filter-pill", !match);
        });
        filterPill = pill;
        updateFilterModes();
    }

    // --- STATS & FILTERS ---
    const fabProgress = document.getElementById("lz-fab-progress");
    const totalAll = parseInt(fabProgress?.dataset.countAll || allItems.length, 10);

    function computeCollectionStats() {
        const total = totalAll || allItems.length;
        let owned = 0;
        let avail = 0;

        allItems.forEach((li) => {
            if (li.classList.contains("lz-owned")) {
                owned++;
            } else if (li.querySelector(".rzc-var-btn:not(.is-disabled)")) {
                avail++;
            }
        });

        return {
            total,
            owned,
            avail,
            pct: total ? Math.round((owned / total) * 100) : 0,
            pot: total ? Math.round(((owned + avail) / total) * 100) : 0
        };
    }

    function renderCollectionStats(stats) {
        const g = stats || computeCollectionStats();

        [root.querySelector(".lz-collection-progress"), fabProgress].filter((w) => w).forEach((wrap) => {
            const target = wrap.querySelector(".lz-collection-progress-inner") || wrap;
            if (!target) return;

            target.querySelector(".lz-collection-progress-count").textContent = `${g.owned} / ${g.total}`;
            target.querySelector(".lz-collection-progress-percent").textContent = `${g.pct}%`;
            target.querySelector(".lz-collection-progress-fill").style.width = `${g.pct}%`;

            const dispo = root.querySelector(".lz-available-switch")?.dataset.on === "1";
            const availFill = target.querySelector(".lz-collection-progress-fill-available");
            if (availFill) {
                availFill.style.width = dispo ? `${g.pot}%` : "0%";
            }
        });
    }

    function updateAllStats() {
        const g = computeCollectionStats();
        renderCollectionStats(g);
        recomputeBulkPills();
        updateFilterModes();
        syncSeriesProgressToSupabase(g);
    }

    function updateFilterModes() {
        const missing = root.querySelector(".lz-missing-switch")?.dataset.on === "1";
        const avail = root.querySelector(".lz-available-switch")?.dataset.on === "1";

        collectionItems.forEach((li) => {
            let hide = li.classList.contains("is-filter-pill");

            if (missing && isCardFullyOwned(li)) hide = true;
            if (avail && !li.querySelector(".rzc-var-btn:not(.is-disabled)")) hide = true;

            li.classList.toggle("is-filter-mode", hide);
        });

        root.classList.toggle("has-filter", allItems.some((li) => li.classList.contains("is-filter-mode")));
    }

    // --- GLOBAL CLICK HANDLER ---
    root.addEventListener("click", async (e) => {
        const disabledBtn = e.target.closest(".rzc-var-btn.is-disabled");
        if (disabledBtn) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showToast("❌ Non Disponible", true);
            return;
        }

        const profileBtn = e.target.closest("a.lz-profile-btn");
        if (profileBtn) {
            if (!isLoggedIn) {
                e.preventDefault();
                e.stopImmediatePropagation();
                showToast("Connecte-toi !");
                window.location.href = loginUrl;
            }
            return;
        }

        const ctrl = e.target.closest(".rzc-ctrl");
        if (ctrl) {
            e.stopImmediatePropagation();
            const pill = ctrl.closest(".rzc-bulk");

            if (ctrl.dataset.action === "cart") {
                const ids = (pill.dataset.ids || "").split(",").map(Number).filter((n) => n);
                pill.dataset.loading = "1";
                pill.insertAdjacentHTML("beforeend", `<div class="rzc-progress-text" style="grid-column:span 2;text-align:center;font-size:11px;">Ajout...</div>`);

                try {
                    for (let i = 0; i < ids.length; i += 25) {
                        await addBatch(ids.slice(i, i + 25).map((id) => ({ id, quantity: 1 })));
                    }
                    showToast(`➕ ${ids.length} ajoutés`);
                    await refreshCartCount();
                } catch (err) {
                    showToast("Erreur", true);
                } finally {
                    pill.dataset.loading = "0";
                    pill.classList.remove("is-open");
                    removeControls(pill);
                    pill.querySelector(".rzc-progress-text")?.remove();
                    recomputeBulkPills();
                }
            }

            if (ctrl.dataset.action === "filter") {
                if (filterPill && filterPill !== pill) {
                    filterPill.dataset.filtering = "0";
                    allItems.forEach((li) => li.classList.remove("is-filter-pill"));
                }

                const on = pill.dataset.filtering === "1";
                pill.dataset.filtering = on ? "0" : "1";

                if (on) {
                    allItems.forEach((li) => li.classList.remove("is-filter-pill"));
                } else {
                    applyFilterForPill(pill);
                }

                updateFilterModes();
            }

            return;
        }

        const pill = e.target.closest(".rzc-bulk");
        if (pill && pill.dataset.loading !== "1") {
            const isOpen = pill.classList.contains("is-open");
            root.querySelectorAll(".rzc-bulk.is-open").forEach((o) => {
                o.classList.remove("is-open");
                removeControls(o);
            });

            if (!isOpen) {
                pill.classList.add("is-open");
                injectControls(pill);
            }
        }

        const sw = e.target.closest(".lz-collection-switch, .lz-missing-switch, .lz-available-switch");
        if (sw) {
            if (!isLoggedIn) {
                showToast("Connecte-toi !");
                window.location.href = loginUrl;
                return;
            }

            const newState = !(sw.dataset.on === "1");
            const type = sw.classList.contains("lz-collection-switch")
                ? "collection"
                : (sw.classList.contains("lz-available-switch") ? "available" : "missing");

            const base = root.querySelector(`.lz-${type}-switch:not(.lz-fab-switch)`);
            if (base) {
                base.dataset.on = newState ? "1" : "0";
                base.classList.toggle("is-on", newState);
                base.setAttribute("aria-pressed", newState);
            }

            const fab = root.querySelector(`.lz-fab-switch[data-control="${type}"]`);
            if (fab) {
                fab.dataset.on = newState ? "1" : "0";
                fab.classList.toggle("is-on", newState);
                fab.closest(".lz-fab-bar-group")?.classList.toggle("is-on", newState);
            }

            if (type === "collection") {
                root.classList.toggle("lz-mode-collection", newState);
            }

            updateAllStats();
            return;
        }

const tglV = e.target.closest(".lz-var-toggle-owned");
if (tglV) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (tglV.dataset.busy === "1") return;
    tglV.dataset.busy = "1";

    if (!isLoggedIn) {
        showToast("Connecte-toi !");
        tglV.dataset.busy = "0";
        window.location.href = loginUrl;
        return;
    }

    const li = tglV.closest(".rzc-item");
    const pid = li.dataset.productId;
    const title = li.querySelector(".rzc-item-title")?.textContent || "";
    
    // On récupère les états actuels
    const isOwned = tglV.dataset.owned === "true";
    const isConfirm = tglV.dataset.confirmRemove === "1";

    let newOwnedState = isOwned;

    // --- LOGIQUE DES 3 ÉTATS ---
    
    // État 1 : On n'a pas la carte (➕) -> On l'ajoute (✅)
    if (!isOwned) {
        newOwnedState = true;
        tglV.dataset.owned = "true";
        tglV.dataset.confirmRemove = "0";
        tglV.classList.remove("is-confirm-remove");
        tglV.textContent = "✅";
    } 
    // État 2 : On a la carte (✅) -> On demande confirmation (➖ rouge)
    else if (isOwned && !isConfirm) {
        tglV.dataset.confirmRemove = "1";
        tglV.classList.add("is-confirm-remove");
        tglV.textContent = "➖";
        tglV.dataset.busy = "0";
        return; // ON ARRÊTE ICI : on attend le prochain clic pour supprimer
    } 
    // État 3 : On est sur le (➖ rouge) -> On supprime vraiment et revient à (➕)
    else {
        newOwnedState = false;
        tglV.dataset.owned = "false";
        tglV.dataset.confirmRemove = "0";
        tglV.classList.remove("is-confirm-remove");
        tglV.textContent = "➕";
    }

    // --- PERSISTANCE & UI ---
    const isPrimary = tglV === getPrimaryVariantToggle(li);
    if (isPrimary) {
        li.classList.toggle("lz-owned", newOwnedState);
        persistOwnedState(pid, newOwnedState, title);
    }

    persistVariantOwnedState(
        tglV.dataset.variantId,
        newOwnedState,
        pid,
        title,
        tglV.dataset.kind
    );

    const form = tglV.closest(".rzc-var-form");
    if (form) {
        form.querySelector(".rzc-var-btn")?.classList.toggle("lz-var-owned", newOwnedState);
    }

    updateAllStats();
    tglV.dataset.busy = "0";
    return;
}
    });

    setTimeout(preloadNextPages, 1000);
})();